// frontend/src/components/cash-close/VarianceCell.js
import React from 'react';
import { useTheme, sans, mono, red, green } from '../../tokens';

const OVER_TINT = '#FDF2EF';
const UNDER_TINT = '#F3F8F4';

export function tintFor(varPct) {
  if (varPct == null || Math.abs(varPct) < 10) return null;
  return varPct > 0 ? OVER_TINT : UNDER_TINT;
}

export default function VarianceCell({ cell, currency = 'CAD', fxRate = 1.37, isSelected, isFuture, onClick, hasNote, compact = false }) {
  const t = useTheme();
  const convertedActual   = currency === 'USD' && cell.actual   != null ? cell.actual / fxRate : cell.actual;
  const convertedForecast = currency === 'USD' && cell.forecast != null ? cell.forecast / fxRate : cell.forecast;
  const convertedVarAmt   = currency === 'USD' && cell.varAmt   != null ? cell.varAmt / fxRate : cell.varAmt;

  const tint = tintFor(cell.varPct);
  const sign = cell.varPct == null ? '' : (cell.varPct > 0 ? '+' : '');
  const pctText = cell.varPct == null ? '—' : `${sign}${cell.varPct.toFixed(0)}%`;
  const amtText = convertedVarAmt == null
    ? '—'
    : (Math.abs(convertedVarAmt) >= 1000
        ? `${convertedVarAmt < 0 ? '-' : '+'}$${Math.round(Math.abs(convertedVarAmt) / 1000)}k`
        : `${convertedVarAmt < 0 ? '-' : '+'}$${Math.round(Math.abs(convertedVarAmt))}`);

  if (isFuture) {
    return (
      <div title={cell.forecast != null ? `Forecast: $${Math.round(Math.abs(convertedForecast)).toLocaleString()}` : ''}
           style={{ textAlign: 'center', color: t.textMuted, fontSize: 14, padding: '4px 6px' }}>·</div>
    );
  }

  return (
    <div
      onClick={cell.actual != null ? onClick : undefined}
      title={cell.actual != null
        ? `Actual: $${Math.round(Math.abs(convertedActual)).toLocaleString()} · Forecast: $${cell.forecast != null ? Math.round(Math.abs(convertedForecast)).toLocaleString() : '—'}`
        : ''}
      style={{
        position: 'relative',
        padding: '4px 6px', textAlign: 'center', cursor: cell.actual != null ? 'pointer' : 'default',
        background: tint || 'transparent',
        outline: isSelected ? `2px solid ${t.borderMedium}` : 'none',
        fontFamily: mono,
      }}
    >
      <div style={{ fontSize: compact ? 10 : 11, fontWeight: 600, color: cell.varPct > 0 ? red : cell.varPct < 0 ? green : t.textSecondary }}>{pctText}</div>
      {!compact && <div style={{ fontSize: 9, color: t.textMuted }}>{amtText}</div>}
      {hasNote && (
        <span style={{ position: 'absolute', top: 2, right: 2, width: 5, height: 5, borderRadius: 3, background: t.borderMedium }} />
      )}
    </div>
  );
}
